var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.77 15.147a.103.103 0 0 1-.176.072l-2.88-2.905a2.75 2.75 0 0 0-3.907.002L.935 15.218a.108.108 0 0 1-.185-.076V2C.75 1.31 1.31.75 2 .75h7.52c.69 0 1.25.56 1.25 1.25z"
  })));
};
export default SvgBookmark;